import { useRef, useEffect, useState } from 'react'
import styles from './AnchorSlider.module.less'
import cls from 'classnames'
import { DASHBOARD_CONTENT_CONTAINER_ID } from '@/router/pageConst'
import { useDebounceEffect } from 'ahooks'

interface Props {
  containerElement: HTMLDivElement | null
  options: Array<{
    label: string
    key: string
  }>
  activeKey: string
  onAnchorClick: (key: string) => void
}

/** 锚点距离顶部距离
 * NOTE:
 * 64 ：顶栏的高度
 * 68 ：Tab 的高度
 * 20 ：调试出来的距离
 */
const OFFSET_TOP = 64 + 68 + 20

function AnchorSlider(props: Props) {
  const [isSticky, setIsSticky] = useState(false)
  const root = useRef<HTMLDivElement | null>(null)
  const optionsWrapper = useRef<HTMLDivElement | null>(null)
  const [top, setTop] = useState(0)

  useDebounceEffect(
    () => {
      if (!optionsWrapper.current || !root.current) {
        return
      }
      const { top: rootTop } = root.current.getBoundingClientRect()
      const activeOption = optionsWrapper.current.querySelector(`.${styles.active}`)
      if (activeOption) {
        const { top } = activeOption.getBoundingClientRect()
        setTop(top - rootTop)
      }
    },
    [props.activeKey],
    {
      wait: 100,
    }
  )

  useEffect(() => {
    const handleScroll = () => {
      const containerOffsetTop = props.containerElement?.getBoundingClientRect().top
      setIsSticky(containerOffsetTop! <= OFFSET_TOP)
    }

    const dashboardContentElement = document.getElementById(DASHBOARD_CONTENT_CONTAINER_ID)
    if (dashboardContentElement) {
      dashboardContentElement.addEventListener('scroll', handleScroll)
    }
    return () => {
      dashboardContentElement?.removeEventListener('scroll', handleScroll)
    }
  }, [props.containerElement])

  return (
    <div
      className={cls(styles.anchorSlider)}
      style={{
        position: isSticky ? 'fixed' : 'relative',
        top: isSticky ? OFFSET_TOP : 'auto',
      }}
      ref={root}
    >
      <div className={styles.sliderBarBox}>
        <div className={styles.sliderBar} style={{ transform: `translateY(${top}px)` }}></div>
      </div>
      <div className={styles.anchorOptions} ref={optionsWrapper}>
        {props.options.map((option) => {
          return (
            <div
              key={option.key}
              className={cls(styles.optionItem, {
                [styles.active]: option.key === props.activeKey,
              })}
              onClick={() => props.onAnchorClick(option.key)}
            >
              {option.label}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AnchorSlider
